import type {
  GradeElementaryMiddle,
  GradeHigh,
  NumberGradeElementary,
  Revision,
  SchoolType,
  Semester,
} from '@mathflat/domain/SchoolSystem'

export const getGradeSubjectSemesterRevisionToKor = ({
  grade,
  semester,
  schoolType,
  subject,
  revision,
}: {
  // 챌린지 응답은 학교 정보가 없을 수 있고(null) 학년을 숫자로 낸다
  grade?: GradeElementaryMiddle | NumberGradeElementary | null
  semester?: Semester
  schoolType?: SchoolType
  subject?: GradeHigh | null
  revision: Revision
}) => {
  const revisionText = revision === 'CURRICULUM_22' ? '(22개정)' : ''

  switch (schoolType) {
    case 'ELEMENTARY':
      return `초${grade ?? ''}-${semester}${revisionText}`

    case 'MIDDLE':
      return `중${grade ?? ''}-${semester}${revisionText}`

    case 'HIGH':
      return `${subject ?? ''}-${semester}${revisionText}`

    default:
      return `-${semester}${revisionText}`
  }
}
